module.exports = __webpack_public_path__ + "img/item-drag.68eb7b54.svg";